module.exports = __webpack_public_path__ + "static/media/logo-perimirim.8f7d264a.png";